import { useState } from 'react';
import { resolveImagePath } from '@/utils/imageResolver';

interface NavigationItem {
  label: string;
  href?: string;
  subItems?: NavigationItem[];
  isActive?: boolean;
}

const navigationItems: NavigationItem[] = [
  {
    label: 'Home',
    href: '/',
    isActive: true
  },
  {
    label: 'About',
    href: '/history/',
    subItems: [
      { label: 'Airfield Information', href: '/airfield-information/' },
      { label: 'Hangers', href: '/hangers/' },
      { label: 'Events & Photos', href: '/events-photos/' },
      { label: 'Service', href: '/service/' },
      { label: 'History', href: '/history/' },
      { label: 'Memorial', href: '/memorial/' }
    ]
  },
  { label: 'Webcams', href: '/webcams/' },
  { label: 'Weather', href: '/weather/' },
  { label: 'Achievement', href: '/achievement/' },
  { label: 'News', href: '/news/' },
  { label: 'Contact', href: '/contact/' }
];

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  const logoSrc = resolveImagePath('/images/logo.png');

  const toggleDropdown = (label: string) => {
    setOpenDropdown(openDropdown === label ? null : label);
  };

  return (
    <header id="header" className="bg-white">
      <div className="container mx-auto px-4">
        {/* Logo Section */}
        <div className="py-4">
          <a href="/" id="logo" className="inline-block">
            <img 
              src={logoSrc} 
              alt="AirHaven Logo" 
              className="h-16 w-auto"
            />
          </a>
        </div>

        {/* Navigation Section */}
        <div className="relative">
          {/* Mobile Menu Button */}
          <button
            id="mobile-menu"
            className="md:hidden bg-blue-600 text-white px-4 py-2 rounded mb-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            Menu
          </button>

          {/* Navigation Menu */}
          <nav className={`${isMenuOpen ? 'block' : 'hidden'} md:block`}>
            <ul className="bg-blue-600 md:flex md:items-center">
              {navigationItems.map((item, index) => (
                <li 
                  key={index}
                  className="relative group"
                  id={`menu-item-${index}`}
                >
                  {item.href && !item.subItems ? (
                    <a
                      href={item.href}
                      className={`block px-4 py-3 text-white hover:bg-blue-700 transition-colors ${
                        item.isActive ? 'bg-blue-700' : ''
                      }`}
                    >
                      {item.label}
                    </a>
                  ) : item.subItems ? (
                    <>
                      <button
                        onClick={() => toggleDropdown(item.label)}
                        className="block w-full text-left px-4 py-3 text-white hover:bg-blue-700 transition-colors md:cursor-pointer"
                      >
                        {item.label}
                        <span className="float-right md:ml-1">▼</span>
                      </button>
                      {/* Dropdown Menu */}
                      <ul 
                        className={`${
                          openDropdown === item.label ? 'block' : 'hidden'
                        } md:absolute md:top-full md:left-0 md:bg-white md:shadow-lg md:border md:min-w-48 md:z-10`}
                      >
                        {item.subItems.map((subItem, subIndex) => (
                          <li key={subIndex}>
                            <a
                              href={subItem.href}
                              className="block px-4 py-2 text-blue-600 hover:bg-blue-50 md:text-gray-800 md:hover:bg-gray-100 transition-colors"
                            >
                              {subItem.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <span className="block px-4 py-3 text-white bg-blue-700">
                      {item.label}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}